import { render, staticRenderFns } from "./OfflineAlert.vue?vue&type=template&id=68dad7a2&"
import script from "./OfflineAlert.vue?vue&type=script&lang=js&"
export * from "./OfflineAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports